import { ReactNode } from 'react'
import { Redirect } from 'react-router'
import Loader from 'components/ui/loader/Loader'
import { AccessConsumer, AccessContextProps } from 'contexts/AccessContext'

interface IProps {
  /** Returns true when the user may enter the route */
  allow: (access: AccessContextProps) => boolean
  children: ReactNode
  fallbackPath?: string
}

/**
 * Route guard based on AccessContext (ABAC). Shows loader while permissions load.
 */
export const RequireAccess = ({
  allow,
  children,
  fallbackPath = '/forbidden',
}: IProps) => (
  <AccessConsumer>
    {(access) => {
      if (access.loading) return <Loader overlay color />
      if (allow(access)) return <>{children}</>
      return <Redirect to={fallbackPath} />
    }}
  </AccessConsumer>
)

export default RequireAccess
